import { getEmojiByName } from "@/assets/emojis";
import EmailViewSummary from "@/domain/entities/dashboard/EmailViewSummary";
import SmartLabel from "@/domain/enums/SmartLabel";
import { customViewRootUrl, smartLabelRootUrl } from "@/router/routes";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EmailProgressBar from "../EmailProgressBar";
import SmartLabelIcon from "../SmartLabelIcon";
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../ui/card";

interface EmailActionCardProps {
    viewInfos: EmailViewSummary;
}

const EmailActionCard = ({ viewInfos }: EmailActionCardProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const isSmartLabel = Object.values(SmartLabel).includes(
        viewInfos.id as unknown as SmartLabel,
    );
    const isFocusView = viewInfos.id === SmartLabel.Focus;

    const redirection = isSmartLabel
        ? `/${smartLabelRootUrl}/${viewInfos.id}`
        : `/${customViewRootUrl}/${viewInfos.id}`;

    return (
        <Card
            className="cursor-pointer"
            onClick={() => navigate(redirection)}
            size="sm"
            variant="dashboard"
        >
            <CardHeader className="h-5">
                {!isSmartLabel &&
                    viewInfos.icon &&
                    getEmojiByName(viewInfos.icon)?.symbol}
                {isSmartLabel && (
                    <SmartLabelIcon
                        smartLabel={viewInfos.id as unknown as SmartLabel}
                    />
                )}
            </CardHeader>
            <CardContent variant="dashboard">
                <CardTitle className="truncate">{viewInfos.title}</CardTitle>
                <CardDescription>
                    {viewInfos.mailCount !== -1 &&
                        t(
                            isFocusView
                                ? "dashboard.infos.emailCard.emailsToProcess"
                                : "dashboard.infos.emailCard.emailsCount",
                            { count: viewInfos.mailCount },
                        )}
                </CardDescription>
            </CardContent>
            <CardFooter>
                <EmailProgressBar viewInfos={viewInfos} />
            </CardFooter>
        </Card>
    );
};

export default EmailActionCard;
